import { css, injectGlobal } from 'styled-components';
import { darken, lighten } from 'polished';

import 'react-widgets/dist/css/react-widgets.css'; // ensure widget assets get parsed properly
import 'font-awesome/css/font-awesome.css';

// eslint-disable-next-line
injectGlobal`
    body {
        margin: 0;
        padding: 0;
        font-family: 'Noto Sans', Arial, sans-serif;
        font-size: 14px;
    }

    a,
    button {
        transition: all .2s linear;
    }

    a:hover,
    a:focus,
    button:hover,
    button:focus {
        opacity: .8;
    }

    ::-webkit-input-placeholder {
        color: #9faab2;
    }
    ::-moz-placeholder {
        color: #9faab2;
    }
    :-ms-input-placeholder {
        color: #9faab2;
    }
    :-moz-placeholder {
        color: #9faab2;
    }

    .ReactModal__Overlay {
        transition: opacity 200ms ease-in-out;
        opacity: 0;
    }

    .ReactModal__Overlay--after-open {
        opacity: 1;
    }

    .ReactModal__Overlay--before-close {
        opacity: 0;
    }

    .ReactModal__Content {
        transition: all 200ms ease-in-out;
        transform: translateY(30px);
        opacity: 0;
    }

    .ReactModal__Content--after-open {
        opacity: 1;
        transform: translateY(0);
    }

    .ReactModal__Content--before-close {
        opacity: 0;
        transform: translateY(30px);
    }
`;

// base colors to be manipulated with helpers to derive variants
const white = '#fff';
const orange = '#e76424';
const blue = '#015172';
const grey = '#2e3b41';
const darkBlue = '#697782';
const offWhite = '#d9d9db';
const red = '#c00';
const green = '#5ea400';
const success = '#5ea400';
const error = '#ec3d3d';
const warning = '#ebad1a';
const info = '#369cc7';

// colors to be made available in styled components
export const colors = {
    white,
    orange: {
        default: orange,
        mid: darken(0.05, orange),
        dark: darken(0.1, orange),
        darkest: darken(0.2, orange),
    },
    blue,
    offWhite,
    offWhiteLighter: lighten(0.1, offWhite),
    grey: {
        default: grey,

        light: lighten(0.1, grey),
        light_mid: lighten(0.5, grey),
        lightest: lighten(0.7, grey),

        dark: darken(0.1, grey),
        darkest: darken(0.2, grey),
    },
    success: {
        default: success,
        lightest: lighten(0.2, success),
    },
    error: {
        default: error,
    },
    warning: {
        default: warning,
    },
    info: {
        default: info,
    },
    red: {
        default: red,
        lightest: lighten(0.2, red),
    },
    green: {
        default: green,
        lightest: lighten(0.2, green),
    },
    darkBlue: {
        default: darkBlue,
        lightest: lighten(0.2, darkBlue),
    },
};

// breakpoint size definitions
const sizes = {
    desktop: 992,
    tablet: 768,
    phone: 376,
};

// Iterate through the sizes and create a media template for
export const media = Object.keys(sizes).reduce((acc, label) => {
    acc[label] = (...args) => css`
		@media (max-width: ${sizes[label] / 16}em) {
			${css(...args)}
		}
	`;

    return acc;
}, {});

// HT: https://gist.github.com/jedfoster/7939513
export const mix = (color_1, color_2, weight) => {
    function d2h(d) {
        return d.toString(16);
    } // convert a decimal value to hex
    function h2d(h) {
        return parseInt(h, 16);
    } // convert a hex value to decimal

    weight = typeof weight !== 'undefined' ? weight : 50; // set the weight to 50%, if that argument is omitted

    var color = '#';

    for (var i = 0; i <= 5; i += 2) {
        // loop through each of the 3 hex pairs—red, green, and blue
        var v1 = h2d(color_1.substr(i, 2)), // extract the current pairs
            v2 = h2d(color_2.substr(i, 2)),
            // combine the current pairs from each source color, according to the specified weight
            val = d2h(Math.floor(v2 + (v1 - v2) * (weight / 100.0)));

        while (val.length < 2) {
            val = '0' + val;
        } // prepend a '0' if val results in a single digit

        color += val; // concatenate val to our new color string
    }

    return color; // PROFIT!
};

export const modalStyles = {
    overlay: {
        backgroundColor: 'rgba(25, 32, 35, 0.7)',
        zIndex: 2,
    },
};



// WEBPACK FOOTER //
// ./src/shared/styles.js